import React, { useState } from 'react';
import { Button, Card, Container, Form, InputGroup, Table } from 'react-bootstrap';

const ApiPartnerWebhookSettings = () => {
  const [showSecrets, setShowSecrets] = useState(false);
  const [formValues, setFormValues] = useState({
    apiToken: 'API-9X5F-72QL-00XA',
    secretKey: '****************',
    upiCallback: '',
    dmtCallback: 'http://localhost/webdekho/v5/php/test/client_callback'
  });

  const handleToggleSecret = () => {
    setShowSecrets((prev) => !prev);
    setFormValues((prev) => ({
      ...prev,
      secretKey: showSecrets ? '****************' : '7a8f-4c92-9dd1-01bf'
    }));
  };

  const handleFieldChange = (event) => {
    const { name, value } = event.target;
    setFormValues((prev) => ({
      ...prev,
      [name]: value
    }));
  };

  const handleUpdate = (fieldLabel) => {
    alert(`${fieldLabel} updated successfully.`);
  };

  return (
    <Container fluid className="api-partner-webhook-settings p-4">
      <div className="mb-4">
        {/* <h2 className="mb-2" style={{ fontSize: '24px', fontWeight: 600, color: '#2c2268' }}>
          API Credentials
        </h2>
        <p className="text-muted mb-0">
          Manage live credentials and callback URLs used for webhook communication. Ensure endpoints respond within 3 seconds.
        </p> */}
      </div>

      <div className="d-flex flex-column gap-4">
        <Card className="shadow-sm border-0">
          <Card.Header className="bg-white border-bottom" style={{ padding: '16px 24px' }}>
            <h5 className="mb-0" style={{ fontWeight: 600, color: '#2c2268' }}>API Credentials</h5>
          </Card.Header>
          <Card.Body className="p-0">
            <Table className="mb-0 credential-table">
              <tbody>
                <tr>
                  <th scope="row">API TOKEN</th>
                  <td>
                    <span className="fw-semibold text-secondary">{formValues.apiToken}</span>
                  </td>
                </tr>
                <tr>
                  <th scope="row">Secret Key</th>
                  <td>
                    <div className="d-flex align-items-center gap-2 flex-wrap">
                      <span className="fw-semibold text-secondary">{formValues.secretKey}</span>
                      <Button variant="outline-secondary" size="sm" onClick={handleToggleSecret}>
                        {showSecrets ? 'Hide' : 'Reveal'}
                      </Button>
                    </div>
                  </td>
                </tr>
                <tr>
                  <th scope="row">UPI/MATM/AEPS CALLBACK</th>
                  <td>
                    <InputGroup className="flex-nowrap">
                      <Form.Control
                        type="url"
                        name="upiCallback"
                        placeholder="https://partner.com/webhooks/upi"
                        value={formValues.upiCallback}
                        onChange={handleFieldChange}
                      />
                      <Button
                        variant="link"
                        className="callback-update-btn"
                        onClick={() => handleUpdate('UPI/MATM/AEPS Callback')}
                      >
                        Update
                      </Button>
                    </InputGroup>
                  </td>
                </tr>
                <tr>
                  <th scope="row">DMT/RECHARGE/BBPS CALLBACK</th>
                  <td>
                    <InputGroup className="flex-nowrap">
                      <Form.Control
                        type="url"
                        name="dmtCallback"
                        placeholder="https://partner.com/webhooks/dmt"
                        value={formValues.dmtCallback}
                        onChange={handleFieldChange}
                      />
                      <Button
                        variant="link"
                        className="callback-update-btn"
                        onClick={() => handleUpdate('DMT/Recharge/BBPS Callback')}
                      >
                        Update
                      </Button>
                    </InputGroup>
                  </td>
                </tr>
              </tbody>
            </Table>
          </Card.Body>
        </Card>
      </div>

      <style jsx="true">{`
        .api-partner-webhook-settings {
          background-color: #fff;
          min-height: calc(100vh - 100px);
        }

        .credential-table tr th {
          width: 260px;
          padding: 18px 24px;
          font-size: 14px;
          text-transform: uppercase;
          letter-spacing: 0.5px;
          color: #1f1f1f;
        }

        .credential-table tr td {
          padding: 18px 24px;
        }

        .credential-table tr:not(:last-child) th,
        .credential-table tr:not(:last-child) td {
          border-bottom: 1px solid #e6e6e6;
        }

        .credential-table tr td .form-control {
          min-width: 260px;
        }

        .callback-update-btn {
          border: 1px solid #dc3545;
          color: #dc3545;
          background: transparent;
          border-radius: 0.375rem;
          padding: 0.375rem 0.75rem;
          margin-left: 12px;
          text-decoration: none;
          transition: all 0.2s ease-in-out;
        }

        .callback-update-btn:hover {
          background-color: #dc3545;
          color: #fff;
        }

        @media (max-width: 992px) {
          .credential-table tr th {
            width: auto;
          }
          .credential-table tr td {
            padding-top: 12px;
            padding-bottom: 12px;
          }
        }
      `}</style>
    </Container>
  );
};

export default ApiPartnerWebhookSettings;
